<template>
  <wapi-panel :title="''">
    <template v-slot:content>
      <div style="height: 415px;">
        <l-map :zoom="13" ref="map" :class="'wapi_map__map'">
          <l-tile-layer url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"></l-tile-layer>
          <l-geo-json
            v-if="geoJson"
            ref="geoJsonLayer"
            :geojson="geoJson"
            :options="geoJsonOptions"
          />
        </l-map>
      </div>
    </template>
  </wapi-panel>
</template>

<script>
import WapiPanel from "../components/WapiPanel";

export default {
  name: "BillingPreset",
  components: {
    WapiPanel
  },
  props: {
    model: Array,
    geoJson: Object,
    markerLatLng: Array
  },
  data() {
    return {
      geoJsonOptions: {
        onEachFeature: (feature, layer) => {
          const bounds = layer.getBounds();
          layer.getLatLng = function() {
            return this.getBounds().getCenter();
          };
          layer.setLatLng = function() {};
          layer._latlng = layer.getLatLng();
          this.$refs.map.mapObject.fitBounds(bounds);
        }
      }
    };
  }
};
</script>